module.exports = __webpack_public_path__ + "static/media/81zyRwwNYrL._SL1500_.1172cf0d.jpg";